<template>
  <b-modal
    centered
    size="md"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">
            {{ $t("globals.set") + " Web App id" }}:
          </h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-input
            class="mt-3"
            v-model.number="new_web_app_id"
            type="text"
            :placeholder="
              existing_web_app_id > 0
                ? existing_web_app_id.toString()
                : 'New web app id'
            "
          >
          </b-input>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="save"
            variant="success"
            :disabled="
              new_web_app_id == null || existing_web_app_id == new_web_app_id
            "
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="cancelModal"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function,
    existing_web_app_id: Number
  },
  data() {
    return {
      new_web_app_id: null
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    ...mapMutations(["setShowLoadingModal"]),
    save() {
      let data = {
        query: `
          mutation CustomerUpdateWebAppId($customer_id: ID!, $new_web_app_id: ID!) {
            res: CustomerUpdateWebAppId (customer_id: $customer_id, new_web_app_id: $new_web_app_id)
          }
        `,
        variables: {
          customer_id: parseInt(this.$route.params.id),
          new_web_app_id: parseInt(this.new_web_app_id)
        }
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelModal();
      });
    },
    cancelModal() {
      this.new_web_app_id = null;
      this.close();
    }
  }
};
</script>
